<div class="transaction_left--container transaction-history--page myacc-cont">
  <div class="transaction_left--content">
    <div class="transaction_left--content_heading myacc-pages-hdng">
      <h2 class="heading"><p>{{'profileSettingsComp.myTransactions' | translate}}</p> <span class="back-icn" (click)="goBack()"> <small class="show-desk">✕</small><i class="icon icon-arrow-2 show-mobile"></i></span></h2>
    </div>
    <div class="myaccount_inner_wrapper">
      <div class="container-fluid">
        <section class="my-transactions">
          <div class="clearfix"></div>
          <div class="transactions_topblock">
            <div class="transactions_container">
              <div>
                <form [formGroup]="txnDetails" (ngSubmit)="applyFilter('filterButton','')" novalidate class="form-holder">
                  <div class="">
                    <div class="custom_padding period-from--field">
                      <h5>{{'bethistoryComp.bethistory5' | translate}}</h5>
                      <div class="form-group mobi-scroll type-select">
                        <input *ngIf="windowType === 'device'" type="text" [max]="maxDate" name="startDate" placeholder="{{'bethistoryComp.bethistory5' | translate}}:"
                          id="startDate" formControlName="startDate" mbsc-datepicker [options]="mobi_desktop_startDate" readonly>
                        <input *ngIf="windowType !== 'device'" type="text" [max]="maxDate" name="startDate" placeholder="{{'bethistoryComp.bethistory5' | translate}}:"
                          id="startDate" formControlName="startDate" mbsc-datepicker [options]="mobi_mobile_startDate" readonly>
                        <div #startDate disabled="false"></div>
                        <div class="arrow_box_small" *ngIf="shouldShowErrors('startDate',txnDetails)">
                          {{getErrorMessage('startDate',txnDetails)}}</div>
                      </div>
                    </div>
                    <div class="custom_padding period-to--field">
                      <h5>{{'bethistoryComp.bethistory6' | translate}}</h5>
                      <div class="form-group mobi-scroll type-select" >
                        <input *ngIf="windowType === 'device'" type="text" [max]="maxDate" name="endDate" placeholder="{{'bethistoryComp.bethistory6' | translate}}:"
                          id="endDate" formControlName="endDate" mbsc-datepicker [options]="mobi_desktop_endDate" readonly>
                        <input *ngIf="windowType !== 'device'" type="text" [max]="maxDate" name="endDate" placeholder="{{'bethistoryComp.bethistory6' | translate}}:"
                          id="endDate" formControlName="endDate" mbsc-datepicker [options]="mobi_mobile_endDate" readonly>
                        <div #endDate disabled="false"></div>
                        
                         <div class="arrow_box_small" *ngIf="shouldShowErrors('endDate',txnDetails)">
                          {{getErrorMessage('endDate',txnDetails)}}</div>
                      </div> 
                    </div>
                    <div class="custom_padding transaction-type--field">
                      <h5>{{'bethistoryComp.bethistory7' | translate}}</h5>
                      <div class="type-select">
                        <select name="items" placeholder="Transaction Types" formControlName="items"
                        class='transaction-type select-dropdown-icon'>
                        <option *ngFor="let txnType of txnTypes" [value]="txnType.key">
                          {{ txnType.value | translate }}
                        </option>
                      </select>
                      <div *ngIf="shouldShowErrors('items',txnDetails)">{{getErrorMessage('items',txnDetails)}}</div>
                      </div>
                    </div>
                    <div class="custom_padding">
                      <button id="filterButton" class="squarebutton filter-btn prefer_btn site-btn site-btn--lg"
                        type="button" (click)="applyFilter('filterButton','')" [disabled]="isButtonDisabled(txnDetails)">
                        <span class='button-text'>{{'bethistoryComp.bethistory8' | translate}}</span>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </div>
    <div class="clearfix"></div>
    <div class="container-fluid">
        <section class="my-transactions">
          <div class="table-content custom_table" *ngIf="!transactions">
            <div class="custom_table-tabledata">
              <ng-container *ngIf="!transactions">
                <div class="transaction_history_block">
                  <h5>{{'bethistoryComp.bethistory9' | translate}}</h5>
                  <p class="empty_box animated-background"></p>
                  <h5>{{'bethistoryComp.bethistory10' | translate}}</h5>
                  <p class="empty_box animated-background"></p>
                  <h5>{{'bethistoryComp.type' | translate}}</h5>
                  <p class="empty_box animated-background"></p>
                  <h5>{{'bethistoryComp.amount' | translate}}</h5>
                  <p class="empty_box animated-background"></p>
                </div>
              </ng-container>
            </div>
          </div>
          <div class="table-content custom_table" *ngIf="transactions">
            <div>
              <ng-container *ngIf="transactions.length > 0">
                <ng-container *ngFor="let transaction of transactions;let i=index;let last = last;" >
                  <div class="transaction_history_block" *ngIf="!(last && transactions.length == noOfTransactions)">
                  <div class="table-data">
                    <h5>{{'bethistoryComp.bethistory9' | translate}}</h5>
                    <p>{{ transaction.time | date : "longDate" }} {{ transaction.time | date: 'mediumTime' }}</p>
                  </div>
                  <div class="table-data">
                    <h5>{{'bethistoryComp.bethistory10' | translate}}</h5>
                    <p>{{transaction.id}}</p>
                  </div>
                  <div class="table-data">
                    <h5>{{'bethistoryComp.type' | translate}}</h5>
                    <ng-container [ngSwitch]="transaction.type">
                      <p *ngSwitchCase="'REAL_CASH_DEPOSIT'">
                        {{'transactionComp.deposits' | translate }}
                      </p>
                      <p *ngSwitchCase="'REAL_CASH_CASHOUT_REVERSAL'">
                        {{'transactionComp.cancelledWithdrawals' | translate }}
                      </p>
                      <p *ngSwitchCase="'REAL_CASH_WITHDRAW'">
                        {{'transactionComp.withdrawals' | translate }}
                      </p>
                      <p *ngSwitchDefault>
                        {{(transaction.operation === "CR" ? 'transactionComp.positiveBalanceAdjustment' : 'transactionComp.negativeBalanceAdjustment') | translate }}
                      </p>
                    </ng-container>
                  </div>
                  <div class="table-data">
                    <h5>{{'bethistoryComp.amount' | translate}}</h5>
                    <p>{{transaction.amount| currencyPipe}}</p>
                  </div>
                </div>
              </ng-container>
              </ng-container>
              <ng-container *ngIf="transactions && transactions.length === 0">
                <div class="transaction_history_block">
                  {{'profileSettingsComp.noTransactionAvail' | translate}}
                </div>
              </ng-container>
              <div class="clearfix"></div>
              <div class="button_margin_mobile button actionbuuton transaction_pagination--btn">
                <button [disabled]="request.index === 0 ? 'true' : ''"
                  [ngClass]="request.index === 0 ? 'hide':''" (click)="applyFilter('','less')" class=" squarebutton filter-result--nextbtn">
                  <i class="icon-left-arrow"></i>
                  <span class="text">{{'bethistoryComp.bethistory17' | translate}}</span>
                </button>
                <button
                  [disabled]="transactions?.length == noOfTransactions ? '' :true"
                  [ngClass]="transactions?.length == noOfTransactions ? '' :'hide'"
                  (click)="applyFilter('','more')" class=" squarebutton filter-result--previousbtn">
                  <span class="text">{{'bethistoryComp.bethistory18' | translate}}</span>
                  <i class="icon-right-arrow"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="clearfix"></div>
        </section>
    </div>
    </div>
  </div>
</div>